import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export { money as cedi, ghsOnly } from "./currency";
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const isoDay = (d) => d.toISOString().slice(0, 10);

export const BELTS = {
  none: { label: "No belt yet", color: "#9ca3af", bg: "#f3f4f6" },
  yellow: { label: "Yellow Belt", color: "#B88A00", bg: "#FFF6CC" },
  green: { label: "Green Belt", color: "#15803d", bg: "#DCFCE7" },
  black: { label: "Black Belt", color: "#111827", bg: "#E5E7EB" },
};

export const EVENT_LABEL = { clock_in: "Clock in", break_start: "Break start", break_end: "Break end", clock_out: "Clock out" };

export async function downloadResume(userId, filename) {
  const res = await api.get(`/resume/${userId}`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "resume";
  a.click();
  URL.revokeObjectURL(url);
}
